import gql from 'graphql-tag';

export const GroupUserFragment = gql`
  fragment GroupUserFragment on GroupUser {
    user {
      id
      firstName
      lastName
      profilePicture {
        url
      }
    }
    permissions {
      edit
      remove
    }
    roles {
      id
      category
    }
  }
`;

export const GroupFrameFragment = gql`
  fragment GroupFrameFragment on GroupFrame {
    frame {
      id
      name
      serialNumber
    }
    permissions {
      remove
    }
  }
`;

export const WeatherLocationFragment = gql`
  fragment WeatherLocationFragment on WeatherLocation {
    id
    geonameId
    source
    latitude
    longitude
    elevation
    timezone
    nameNb
    nameEn
    nameLocal
    typeNb
    typeEn
    geonamesFeatureClass
    geonamesFeatureCode
    municipality
    county
    countryNb
    countryEn
    urlNb
    urlEn
    order
  }
`;

export const FrameWeatherFragment = gql`
  fragment FrameWeatherFragment on FrameWeather {
    locationId
    location {
      ...WeatherLocationFragment
    }
  }
  ${WeatherLocationFragment}
`;
